export const checksums = {
  "leaderboardDocs": "v3.5.0--Y8hOHD3wFWpqIDlt2mF3BitZ-9W6XhfKiLEfGLHtb8M",
  "testimonials": "v3.5.0--gt7g2GQ-qk1Ls3ti1o7AckLhb8rYaBQmQMy3onHYe2U",
  "pages": "v3.5.0--9Ye7mwtR4IeNQ1m7ZWgwqz965W1LF_im-Oq9vyL_ZCM",
  "snippets": "v3.5.0--WLh6eC_INBrpQAs8NmXe2rW506O5MKjLi9hF-YxaiHI"
}
export const checksumsStructure = {
  "leaderboardDocs": "xyk9qIWZFjZlW-umqxeh1sTIdR05Z-zeNDbm-6QAD44",
  "testimonials": "gt7g2GQ-qk1Ls3ti1o7AckLhb8rYaBQmQMy3onHYe2U",
  "pages": "wBuB0tn25cLl4pIErfCq3S4Sa5BiSPuBIXPr4EeLd5w",
  "snippets": "F4JcZcw2_RsZH1nskU8KINTvK8c_79GqwaYixuAs_-M"
}

export const tables = {
  "leaderboardDocs": "_content_leaderboardDocs",
  "testimonials": "_content_testimonials",
  "pages": "_content_pages",
  "snippets": "_content_snippets",
  "info": "_content_info"
}

export default {
  "leaderboardDocs": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "updatedAt": "string"
    }
  },
  "testimonials": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "avatar": "string",
      "company": "string",
      "companyLogo": "string",
      "enabled": "boolean",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "order": "number",
      "quote": "string",
      "stem": "string"
    }
  },
  "pages": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "headline": "string",
      "heroImage": "string",
      "icon": "string",
      "introduction": "boolean",
      "meta": "json",
      "navigation": "json",
      "ogImage": "string",
      "order": "number",
      "path": "string",
      "publishedAt": "string",
      "seo": "json",
      "stem": "string",
      "updatedAt": "string",
      "wistiaId": "string"
    }
  },
  "snippets": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}